'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var extend = require('../util/extend');
var EM = require('./model');
var DB = require('../util/db');
var Category = require('../constant/category');
var Level = require('../constant/level');
var Logger = require('../util/logger');
var Util = require('../util/index');
var Url = require('../util/url');
var Logan = require('../util/logan');
var Version = require('../constant/version').version;
var NAME = 'error';

var encodeDataBeforeSend = function encodeDataBeforeSend(data) {
    return 'c=' + encodeURIComponent(JSON.stringify(data));
};

var doSend = function doSend(opts) {
    if (opts && opts.data) {
        return Ajax({
            url: opts.url,
            type: 'POST',
            header: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: encodeDataBeforeSend(opts.data),
            success: opts.success,
            fail: opts.fail,
            xhrRewritten: opts.xhrRewritten
        });
    }
};

// Owl 错误管理类

var ErrorManager = function () {
    function ErrorManager(cfgManager) {
        _classCallCheck(this, ErrorManager);

        this.cfgManager = cfgManager;
        this.cache = [];
        this.cacheSending = {};
        this.comboTimeout = 0;
        this.timeLimit = Date.now();
        this.errorCount = 0;
        this.isTimeLimit = false;
        this.detectLeave();
    }
    // 解析 window.onerror 采集到的 JS 错误


    _createClass(ErrorManager, [{
        key: 'parseWindowError',
        value: function parseWindowError(msg, url, line, col, error) {
            try {
                if (error && error.stack) {
                    // this.push(error)
                    error = this._processError(error);
                    if (error.sec_category !== 'Invalid_Error') {
                        error.rowNum = error.rowNum || line;
                        error.colNum = error.colNum || col;
                        error.resourceUrl = error.resourceUrl || url;
                    }
                    this._push(error);
                } else if (typeof msg === 'string') {
                    this._push({
                        category: Category.SCRIPT,
                        sec_category: msg,
                        resourceUrl: url,
                        rowNum: line,
                        colNum: col
                    });
                }
            } catch (e) {
                this.reportSystemError(e);
            }
        }
        // 处理 unhandledrejection 错误

    }, {
        key: 'parsePromiseUnhandled',
        value: function parsePromiseUnhandled(event) {
            if (!(event && event.type === 'unhandledrejection')) return;

            try {
                var reason = event.reason;
                if (reason) {
                    var name = 'unhandledrejection';
                    var stack = '';
                    if (reason instanceof Error) {
                        var errName = reason.message || reason.name || '';
                        if (errName && this.cfgManager.get(NAME).formatUnhandledRejection) {
                            name = '[unhandledrejection] ' + errName;
                        }
                        stack = reason.stack || reason.toString() || '';
                    } else {
                        stack = reason;
                    }
                    this._push({
                        category: Category.SCRIPT,
                        sec_category: name,
                        content: stack
                    });
                }
            } catch (e) {
                this.reportSystemError(e);
            }
        }
    }, {
        key: 'parseConsoleError',
        value: function parseConsoleError() {
            try {
                var args = Array.prototype.slice.call(arguments);
                if (!(args && args.length)) return;

                var contents = [];
                for (var i = 0; i < args.length; i++) {
                    var arg = args[i];
                    if (arg) {
                        var msg = '';
                        if (typeof arg === 'string') {
                            msg = arg;
                        } else if (arg instanceof window.Error) {
                            msg = arg.stack || arg.message || '';
                        } else if (arg instanceof window.ErrorEvent) {
                            msg = arg.error && (arg.error.stack || arg.error.message) || arg.message || '';
                        } else {
                            msg = JSON.stringify(arg);
                        }
                        contents.push(msg);
                    }
                }

                if (contents && contents.length) {
                    this._push({
                        category: Category.SCRIPT,
                        sec_category: 'consoleError',
                        content: contents.join(' ')
                    });
                }
            } catch (e) {
                this.reportSystemError(e);
            }
        }
        // 监听页面卸载事件, 异步上报或存储还未上报的异常

    }, {
        key: 'detectLeave',
        value: function detectLeave() {
            var _this = this;

            try {
                var origin = window.onbeforeunload;
                window.onbeforeunload = function () {
                    var cacheDisabled = _this.cfgManager.get('disableCache') || window.Owl && window.Owl.cfgManager.get('disableCache');
                    var useSendBeacon = _this.cfgManager.get('useSendBeacon') && window.navigator && window.navigator.sendBeacon;
                    if (!cacheDisabled || useSendBeacon) {
                        var cacheCombined = _this.addCacheExtension(); // 1.未进入上报流程
                        var cacheSending = _this.cacheSending; // 2.上报流程未结束
                        if (cacheSending && Object.keys(cacheSending).length) {
                            for (var key in cacheSending) {
                                try {
                                    if (cacheSending.hasOwnProperty(key) && cacheSending[key]) {
                                        var _cacheSending$key = cacheSending[key],
                                            xhr = _cacheSending$key.xhr,
                                            cache = _cacheSending$key.cache;

                                        xhr.abort();
                                        if (cache instanceof Array && cache.length) {
                                            cacheCombined = cacheCombined.concat(cache);
                                        }
                                    }
                                } catch (e) {
                                    Logger.ignore(e);
                                }
                            }
                        }
                        if (cacheCombined && cacheCombined.length) {
                            if (useSendBeacon) {
                                var url = Url.stringify(_this.cfgManager.getApiPath(NAME), {
                                    pageId: _this.cfgManager.get('pageId'),
                                    beacon: 1
                                });
                                window.navigator.sendBeacon(url, encodeDataBeforeSend(cacheCombined));
                            } else if (!cacheDisabled) {
                                DB.add(cacheCombined, _this.cfgManager.get('webVersion'));
                            }
                        }
                    }
                    origin && origin.call();
                };
            } catch (e) {
                Logger.ignore(e);
            }
        }
        // 读取并上报 localStorage 中历史上报失败后存储的异常

    }, {
        key: 'checkCache',
        value: function checkCache() {
            var _this2 = this;

            setTimeout(function () {
                var preCache = DB.get();
                DB.clearAll();
                if ((typeof preCache === 'undefined' ? 'undefined' : _typeof(preCache)) === 'object' && Object.keys(preCache).length) {
                    var cfgManager = _this2.cfgManager;
                    var currVer = cfgManager.get('webVersion') || '';
                    var originUrl = cfgManager.getApiPath(NAME);
                    for (var key in preCache) {
                        try {
                            var data = preCache[key];
                            if (data instanceof Array && data.length) {
                                var cacheVer = key === 'no-version' ? '' : key;
                                var url = cacheVer !== currVer ? Url.replaceParam(originUrl, 'webVersion', cacheVer) : originUrl;
                                doSend({
                                    url: url,
                                    data: data,
                                    xhrRewritten: cfgManager.get('autoCatch').ajax ? true : false
                                });
                            }
                        } catch (e) {
                            _this2.reportSystemError(e);
                        }
                    }
                }
            }, 4000);
        }
    }, {
        key: 'reportSystemError',
        value: function reportSystemError(err) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (!err) return;
            try {
                this.cache.push(new EM({
                    project: 'owl',
                    pageUrl: 'version_' + Version,
                    category: opts.category || Category.SCRIPT,
                    level: opts.level || Level.ERROR,
                    realUrl: Util.getHref(),
                    sec_category: err.message || err.name || 'parseError',
                    content: err.stack ? JSON.stringify(err.stack) : err.toString && err.toString() || ''
                }));
                this.send(true);
            } catch (e) {}
        }
    }, {
        key: 'reportSystemWarn',
        value: function reportSystemWarn(err, opts) {
            if (!err) return;
            opts = opts || {};
            opts.level = Level.WARN;
            this.reportSystemError(err, opts);
        }
    }, {
        key: '_processError',
        value: function _processError(errObj) {
            var doFallback = function doFallback(err) {
                var name = err.message || err.name || 'Invalid_Error';
                var content = err instanceof Error ? err.toString() : JSON.stringify(err);
                return {
                    category: Category.SCRIPT,
                    sec_category: name,
                    content: content
                };
            };

            var doParse = function doParse(err) {
                if (err.stack) {
                    var info = err.stack.match('https?://[^\n]+');
                    info = info ? info[0] : '';
                    var jsReg = /https?:\/\/(\S)+\.js/;
                    var scriptUrl = jsReg.test(info) ? info.match(jsReg)[0] : '';
                    var rowCols = info.match(':(\\d+):(\\d+)');
                    if (!rowCols) {
                        rowCols = [0, 0, 0];
                    }

                    return {
                        category: Category.SCRIPT,
                        sec_category: err.message || err.name || '',
                        content: err.stack,
                        resourceUrl: scriptUrl,
                        rowNum: rowCols[1],
                        colNum: rowCols[2]
                    };
                } else {
                    return doFallback(err);
                }
            };

            try {
                return doParse(errObj);
            } catch (e) {
                this.reportSystemError(e);
                return doFallback(errObj);
            }
        }
    }, {
        key: '_push',
        value: function _push(error, opts) {
            error = this.parse(error);
            this.push(new EM(error), opts);
        }
        // 向错误队列增加资源错误 resourceError

    }, {
        key: '_pushResource',
        value: function _pushResource() {
            if (Math.random() > this.cfgManager.get('resource').sample) return;
            this._push.apply(this, arguments);
        }
        // 统一处理错误属性

    }, {
        key: 'parse',
        value: function parse(error) {
            if (!error.project) {
                error.project = this.cfgManager.get('project');
            }
            if (!error.pageUrl) {
                error.pageUrl = this.cfgManager.get('pageUrl') || 'default';
            }
            if (!error.unionId) {
                error.unionId = this.cfgManager.getExtension('unionId');
            }
            error.realUrl = Util.getHref();

            return error;
        }
        // 格式化错误信息并 push 至错误队列中

    }, {
        key: 'push',
        value: function push(error, opts) {
            var cfgManager = this.cfgManager;
            var errCfg = cfgManager.get(NAME);
            if (!error || Math.random() > errCfg.sample) return;

            // format as ErrorModel
            if (!(error instanceof EM)) {
                if (error instanceof Error) {
                    error = this._processError(error);
                } else if (typeof error === 'string') {
                    error = { sec_category: error };
                } else if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object') {
                    error = {
                        sec_category: error.name || '',
                        content: error.msg || ''
                    };
                }
                error = this.parse(error);
                error = new EM(error);
            }
            if (error.content && error.content.length >= errCfg.maxSize) return;

            error.update(opts);
            try {
                var seen = [];
                var logInfo = JSON.stringify(error.toLoganJson(), function (k, v) {
                    if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null) {
                        if (seen.indexOf(v) >= 0) {
                            return;
                        }
                        seen.push(v);
                    }
                    return v;
                });
                Logan._log('[Error]:' + logInfo, 'owl', error.level, [error.category]);
            } catch (e) {
                this.reportSystemError(e);
            }

            // 异常过滤策略 (Script error / filters / ignoreList.js)
            var isValid = true;
            if (cfgManager.get('noScriptError') && error.sec_category.indexOf('Script error') === 0) {
                return isValid = false;
            }
            var filters = cfgManager.filters;
            if (filters && filters.length) {
                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    if (!filter.fn(error)) {
                        return isValid = false;
                    }
                }
            }
            var ignoreErrors = cfgManager.get('ignoreList').js;
            if (ignoreErrors && ignoreErrors.length) {
                for (var _i = 0; _i < ignoreErrors.length; _i++) {
                    if (error.sec_category.indexOf(ignoreErrors[_i]) === 0) {
                        isValid = false;
                        break;
                    }
                }
            }
            if (!isValid) return;

            // 广播自定义事件, 告知外部采集到了有效的异常信息
            try {
                if (window && window.dispatchEvent && error && error.getEventInfo) {
                    var eventInfo = error.getEventInfo({
                        'pageId': cfgManager.get('pageId') || ''
                    });
                    var errEvent = void 0;
                    if (typeof window.CustomEvent === 'function') {
                        errEvent = new CustomEvent('owlErrDetected', { 'detail': eventInfo });
                    } else if (document && typeof document.createEvent === 'function') {
                        // polyfill CustomEvent for IE9+
                        var evt = document.createEvent('CustomEvent');
                        if (typeof evt.initCustomEvent === 'function') {
                            errEvent = evt.initCustomEvent('owlErrDetected', false, false, eventInfo);
                        }
                    }
                    errEvent && window.dispatchEvent(errEvent);
                }
            } catch (e) {
                this.reportSystemError(e);
            }

            if (!this.isExist(error)) {
                error = this._handleError(error);
                if (error) {
                    this.cache.push(error);
                    this.send();
                }
            }
        }
        // 判断错误是否已存在当前错误队列中

    }, {
        key: 'isExist',
        value: function isExist(error) {
            for (var i = 0; i < this.cache.length; i++) {
                var element = this.cache[i];
                if (!(element instanceof EM)) {
                    element = new EM(element);
                }
                if (element.isEqual(error)) {
                    return true;
                }
            }
            return false;
        }
        // 异常上报前的拦截处理

    }, {
        key: '_handleError',
        value: function _handleError(instance) {
            try {
                var hook = this.cfgManager.get('onErrorPush');
                if (hook instanceof Function) {
                    instance = hook(instance);
                }
                if (instance instanceof EM || instance === undefined) {
                    return instance;
                } else {
                    Logger.ignore('onErrorPush 方法的返回值仅能为ErrorModel实例或undefined');
                }
            } catch (e) {
                Logger.ignore('onErrorPush 方法处理有误', e);
                return instance;
            }
        }
    }, {
        key: 'report',
        value: function report() {
            this.push.apply(this, arguments);
            this.send(true);
        }
        // 异常上报流程

    }, {
        key: 'send',
        value: function send(isReportNow) {
            var _this3 = this;

            var cfgManager = this.cfgManager;
            var errCfg = cfgManager.get(NAME);
            var comboTimeout = this.comboTimeout;

            // 限制 maxTime 内上报的异常数不能超过 maxNum
            var maxError = errCfg.maxNum || 100;
            var maxTime = errCfg.maxTime || 60 * 1000;
            var timeLimit = Date.now() - this.timeLimit;
            if (!this.isTimeLimit) {
                this.timeLimit = Date.now();
            }
            this.isTimeLimit = true;

            var comboReport = function comboReport() {
                if (!_this3.cache.length) return;

                clearTimeout(comboTimeout);
                comboTimeout = 0;

                try {
                    _this3.errorCount += _this3.cache.length;
                    if (timeLimit <= maxTime) {
                        if (_this3.errorCount >= maxError) return;
                    } else {
                        _this3.isTimeLimit = false;
                        _this3.errorCount = 0;
                    }
                } catch (e) {
                    Logger.ignore(e);
                }

                var cache = _this3.addCacheExtension();
                var ts = +new Date();
                var xhr = doSend({
                    url: cfgManager.getApiPath(NAME) + ('&pageId=' + cfgManager.get('pageId')),
                    data: cache,
                    success: function success() {
                        _this3.cacheSending[ts] = undefined;
                    },
                    fail: function fail() {
                        try {
                            if (!(cfgManager.get('disableCache') || window.Owl && window.Owl.cfgManager.get('disableCache'))) {
                                var record = _this3.cacheSending[ts];
                                if (record && record.cache && record.cache.length) {
                                    DB.add(record.cache, cfgManager.get('webVersion'));
                                }
                            }
                            _this3.cacheSending[ts] = undefined;
                        } catch (e) {
                            _this3.cacheSending[ts] = undefined;
                            Logger.ignore(e);
                        }
                    },
                    xhrRewritten: cfgManager.get('autoCatch').ajax ? true : false
                });
                _this3.cacheSending[ts] = { xhr: xhr, cache: cache };
                _this3.cache = [];
            };

            var delay = errCfg.delay;
            if (isReportNow) {
                comboReport();
            } else if (!comboTimeout && delay !== -1) {
                comboTimeout = setTimeout(comboReport, delay);
            }
        }
        // 绑定 Extension 扩展信息

    }, {
        key: 'addCacheExtension',
        value: function addCacheExtension() {
            var cache = this.cache;
            var ret = [];
            if (!(cache && cache.length)) return ret;

            var ext = this.cfgManager.getExtension();
            for (var i = 0; i < cache.length; i++) {
                var error = cache[i];
                if (ext && (typeof ext === 'undefined' ? 'undefined' : _typeof(ext)) === 'object') {
                    error = extend(error.toJson(), ext);
                }
                ret.push(error);
            }
            return ret;
        }
    }]);

    return ErrorManager;
}();

module.exports = ErrorManager;